import { createMock } from '../../utils/builderHelper.es.js';

const aCurrency = createMock({
    currencyCode: 'USD',
    currencySymbol: '$',
});

export { aCurrency };
